module.exports = __webpack_public_path__ + "static/assets/ed77eba63b927293ceb51ee9c20f516f.png";